// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"05c56701","450":"cbbc3e11"}[chunkId] + ".chunk.js";
};